import ApiResponse from "sr/models/ApiResponse";
import { post } from "sr/utils/axios";

export type FeeTransparencyJobType = "workorder" | "individual";

export type FeeTransparencyRequest = {
  jobType: FeeTransparencyJobType;
  amount: number;
  start_time?: string;
  end_time?: string;
};

export type FeeTransparencyData = {
  amount: number;
  platform_fee: number;
  total_stripe_amount: number;
  totalHoursDecimal: number;
  job_seeker_fee_amount: number;
  job_provider_fee_amount: number;
  job_provider_paid_amount: number;
  job_seeker_received_amount: number;
};

export const getFeeTransparency = async (payload: FeeTransparencyRequest) => {
  return await post<ApiResponse<FeeTransparencyData>>(
    "/fee/transparency",
    payload as any
  );
};

